export default "__VITE_ASSET__5dcaa3bc__"